import Vue from 'vue'
import configs from '../config'

let resource = null

const actions = {
  getAudienceTitle: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenter-milestones/audience-title/{presenterId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getAudienceTitle = async (presenterId) => {
  const res = await resource.getAudienceTitle({ presenterId })
  return res.body && res.body.title
}

export default {
  initResource,
  getAudienceTitle,
}
